import styled from 'styled-components';

const StyledHeroProductsStatic = styled.div`
  position: relative;
  min-height: 100vh;
  background-color: #fff;
  padding-top: 174px;
  .content--wrap{
    position: absolute;
    width: 41.65%;
    left: 50%;
    top: 174px;
    bottom: 0;
    transform: translateX(-50%);
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
  }
  .content--wrap .mask--title{
    position: absolute;
    width: 100%;
    height: 100%;
    color: #fff;
    z-index: 2;
    overflow:hidden;
  }
  .content--wrap  .background--cover-img {
    display: block;
    width: 100%;
    height: 100%;
    border-top-left-radius:16px;
    border-top-right-radius:16px;
    overflow: hidden;
    background-size: cover;
    background-position: ${props => props.bgPosition ? props.bgPosition : '50%'};
  }
  h4{
    position: absolute;
    width: 180%;
    top: 50%;
    left: -40%;
    transform:translateY(-50%);
    text-align: center
  }
  @media screen and (max-width: 1439px){
    
  }
  @media screen and (max-width: 1023px){
    .content--wrap{
      width: 66.66%;
      margin: 0 auto ;
    }
    h4{
      width: 140%;
      left: -20%;
    }
  }
  @media screen and (max-width: 767px){
    padding: 120px 24px 0;
    .content--wrap{
      width: 80%;
      top: 120px;
      margin: 0 auto;
    }
    h4{
      width: 120%;
      left: -10%;
    }
    
  }
`;

export {
  StyledHeroProductsStatic,
};

